module.exports = __webpack_public_path__ + "static/media/sellerB2B-ar.4e19ff18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/sellerB2B-ar.svg
// module id = 855
// module chunks = 2